export enum INTEGRATION_EVENTS {
  PAGE_SELECTION_CHANGED = "page-selection-changed"
}
